export default __webpack_public_path__ + "static/media/humanoid_main_screen.f9019135.png";